import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import notificationService, { Notification } from '../services/notificationService';
import notificationAnalytics from '../services/notificationAnalytics';

export function useNotifications() {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setNotifications([]);
      setUnreadCount(0);
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = notificationService.subscribeToNotifications(
      user.uid,
      (newNotifications) => {
        setNotifications(newNotifications);
        setUnreadCount(newNotifications.filter(n => !n.read).length);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user?.uid]);

  const markAsRead = async (notificationId: string) => {
    await notificationService.markAsRead(notificationId);
    
    // Track analytics: opened
    const notification = notifications.find(n => n.id === notificationId);
    if (notification && user?.uid) {
      await notificationAnalytics.trackEvent(
        notificationId,
        user.uid,
        notification.type,
        'opened'
      );
    }
  };

  const markAllAsRead = async () => {
    if (!user?.uid) return;
    await notificationService.markAllAsRead(user.uid);
  };

  return {
    notifications,
    unreadCount,
    loading,
    markAsRead,
    markAllAsRead,
  };
}
